import React, { useState, useRef, useEffect } from 'react'
import { Button } from 'antd'
import './SettingsDropdown.scss'
import { useTranslation } from 'react-i18next'

const SettingsDropdown = ({ onSettingsClick }) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const handleOptionClick = option => {
    setIsOpen(false)
    onSettingsClick(option)
  }
  const { t } = useTranslation()
  return (
    <div className="settings-dropdown" ref={dropdownRef}>
      <Button
        icon="setting"
        className="welcome-top__right"
        type="primary"
        onClick={handleToggle}
      >
        {t('labels:settings')}
      </Button>

      {isOpen && (
        <div className="settings-dropdown__menu">
          <div
            className="settings-dropdown__option"
            onClick={() => handleOptionClick('competitions')}
          >
            {t('v4:competitions')}
          </div>
          <div className="settings-dropdown__separator"></div>
          <div
            className="settings-dropdown__option"
            onClick={() => handleOptionClick('leaderboards')}
          >
            {t('v4:leaderboards')}
          </div>
        </div>
      )}
    </div>
  )
}

export default SettingsDropdown
